import { useState } from 'react';
import Input from '@/components/Input';
import useUpdateJobSource from '../../api/useUpdateJobSource';
import { showErrorToast, showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';
import LinkedAccountEditFieldModal from './LinkedAccountEditFieldModal';

type Props = {
  isOpen: boolean;
  jobSourceId: number;
  currentBasicAuthId: string | null;
  onClose: () => void;
  onSaved: () => Promise<unknown>;
};

export default function LinkedAccountEditBasicAuthModal({
  isOpen,
  jobSourceId,
  currentBasicAuthId,
  onClose,
  onSaved,
}: Props) {
  const [basicAuthId, setBasicAuthId] = useState(currentBasicAuthId ?? '');
  const [basicAuthPass, setBasicAuthPass] = useState('');
  const updateJobSource = useUpdateJobSource();

  const handleSubmit = async () => {
    try {
      await updateJobSource.mutateAsync({
        id: jobSourceId,
        basic_auth_id: basicAuthId,
        basic_auth_pass: basicAuthPass,
      });
      await onSaved();
      showSuccessToast('Basic 認証情報を更新しました');
      onClose();
    } catch {
      showErrorToast('Basic 認証情報の更新に失敗しました');
    }
  };

  return (
    <LinkedAccountEditFieldModal
      isOpen={isOpen}
      title="Basic 認証を編集"
      isPending={updateJobSource.isPending}
      // 未登録の場合はパスワードも必須(新規作成)
      canSubmit={!!basicAuthId && (!!currentBasicAuthId || !!basicAuthPass)}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col gap-xs">
        <label className="text-heading-xxs">ID</label>
        <Input
          value={basicAuthId}
          onChange={(e) => setBasicAuthId(e.target.value)}
          className="h-[42px] w-full"
          disabled={updateJobSource.isPending}
        />
      </div>
      <div className="flex flex-col gap-xs">
        <label className="text-heading-xxs">パスワード</label>
        <Input
          type="password"
          value={basicAuthPass}
          onChange={(e) => setBasicAuthPass(e.target.value)}
          className="h-[42px] w-full"
          placeholder={
            currentBasicAuthId ? '変更する場合は新しいパスワードを入力' : 'パスワードを入力'
          }
          disabled={updateJobSource.isPending}
        />
      </div>
    </LinkedAccountEditFieldModal>
  );
}
